import React from "react";
import { ArrowRight } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { ConsulenzaForm } from "../components/ConsulenzaForm";

const CALENDLY_URL =
  "https://calendly.com/spinazzola-francesca/15-min-di-call-gratuita-clone?utm_id=97760_v0_s00_e0_tv3";

export default function Consulenze() {
  return (
    <div className="App consulenze-page" data-testid="consulenze-page">
      <Header />

      <section className="prodotti-hero cons-hero">
        <p className="section-eyebrow">Consulenze</p>
        <h1 className="prodotti-title serif">Parliamo della tua struttura</h1>
        <p className="prodotti-sub">
          Scegli il tipo di call più adatto a te: una prima chiacchierata gratuita
          o una consulenza 1:1 approfondita.
        </p>
      </section>

      <div className="cons-wrap">
        <article className="cons-card" data-testid="cons-free-card">
          <img src="/consulenze/call-15-min.webp" alt="Call gratuita di 15 minuti" className="cons-img" />
          <div className="cons-body">
            <p className="section-eyebrow">Gratuita · 15 minuti</p>
            <h2 className="cons-title serif">Call conoscitiva gratuita</h2>
            <p className="cons-text">
              Quindici minuti per conoscerci: mi racconti la tua struttura, i tuoi
              obiettivi e le difficoltà che stai incontrando. Insieme capiamo se e come
              posso aiutarti a renderla più attraente e a ricevere più prenotazioni.
            </p>
            <a
              href={CALENDLY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="quiz-cta cons-cta"
              data-testid="cons-calendly-btn"
            >
              Prenota la call gratuita <ArrowRight size={18} strokeWidth={1.8} />
            </a>
          </div>
        </article>

        <article className="cons-card" data-testid="cons-paid-card">
          <img src="/consulenze/call-1-ora.webp" alt="Consulenza 1:1 di un'ora" className="cons-img" />
          <div className="cons-body">
            <p className="section-eyebrow">1:1 · 1 ora</p>
            <h2 className="cons-title serif">Consulenza 1:1 con Francesca</h2>
            <p className="cons-price" data-testid="cons-price">€ 50</p>
            <p className="cons-text">
              Un'ora dedicata solo a te per rivedere insieme foto, annuncio,
              disposizione degli spazi e arredamento. Riceverai consigli concreti per
              migliorare l'immagine della tua struttura e darle il posizionamento che
              merita.
            </p>
            <p className="cons-note">
              Compila il modulo: ti ricontatterò via email o telefono entro qualche ora
              per confermare l'appuntamento e le modalità di pagamento.
            </p>
            <ConsulenzaForm />
          </div>
        </article>
      </div>

      <Footer />
    </div>
  );
}
